import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EMAIL_PATTERN } from '@cakeiteasy/web-utils';

@Component({
  standalone: false,
  selector: 'contact-us-form',
  templateUrl: './contact-us-form.component.html'
})
export class ContactUsFormComponent {
  @Input() isSuccess = false;
  @Input() showBack: boolean = true;
  @Output() onSend = new EventEmitter<any>();
  @Output() onFormChange = new EventEmitter<void>();

  public contactUsForm: FormGroup;
  public EMAIL_PATTERN = EMAIL_PATTERN;

  constructor(private _fb: FormBuilder) {
    this.contactUsForm = this._fb.group({
      userName: ['', [Validators.required, Validators.maxLength(32)]],
      email: ['', [Validators.required, Validators.maxLength(128)]],
      city: ['', [Validators.required, Validators.maxLength(64)]],
      phone: ['', [Validators.maxLength(32)]],
      message: ['', [Validators.required, Validators.maxLength(512)]]
    });
  }

  public send() {
    this.onSend.emit(this.contactUsForm.value);
  }
}
